<template>
  <div class="
  line
  tw-mx-auto tw-my-[56px]
  tw-h-[2px] tw-w-full
  tw-bg-[#D7E3E3]">
  </div>
</template>

<script>
export default {
  name: "UIFullDivider"
}
</script>

<style scoped>

</style>
